import { render, staticRenderFns } from "./LogsDataTable.vue?vue&type=template&id=8941d89c&scoped=true"
import script from "./LogsDataTable.vue?vue&type=script&lang=js"
export * from "./LogsDataTable.vue?vue&type=script&lang=js"
import style0 from "./LogsDataTable.vue?vue&type=style&index=0&id=8941d89c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8941d89c",
  null
  
)

export default component.exports